import { createContext, useContext, useState } from "react";

const ToastContext = createContext();

const ToastProvider = ({children})=>{

    const [mainMessage , setMainMessage] = useState();
    
    return(
        <ToastContext.Provider value={{mainMessage , setMainMessage}}>{children}</ToastContext.Provider>
    )
}

const UseToast =()=> useContext(ToastContext)

export {UseToast,ToastProvider}